
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-by-location",
      function () {
        return require("private-next-pages/job-by-location.tsx");
      }
    ]);
  